import React from 'react'
import { default as PaginationDefault } from 'react-js-pagination'
import Select from '../_library/Select'
import CustomToggle from './CustomToggle'

export const Pagination = ({
  activePage,
  pageRangeDisplayed,
  itemsCountPerPage,
  totalItemsCount,
  onChange,
  pageSizeOptions = [],
  onPageSizeChange,
  addDisplayAllData,
  onChangeDisplayAllDataCheckbox,
  disablePageSize,
}) => {
  const enablePageSizeSelect = Boolean(pageSizeOptions && pageSizeOptions.length)

  return (
    <div className="pagination-box">
      <div className="pagination-container">
        <PaginationDefault
          activePage={activePage}
          pageRangeDisplayed={pageRangeDisplayed}
          itemsCountPerPage={itemsCountPerPage}
          totalItemsCount={totalItemsCount}
          onChange={onChange}
        />
        {!disablePageSize && enablePageSizeSelect && (
          <div className="pagination-select">
            <Select
              label="Page Size"
              value={itemsCountPerPage}
              options={pageSizeOptions}
              onSelect={onPageSizeChange}
            />
          </div>
        )}
      </div>
      {addDisplayAllData ? (
        <div className="toggle-pagination">
          <CustomToggle
            onText="Display all data into table"
            checked={disablePageSize}
            onChange={onChangeDisplayAllDataCheckbox}
          />
        </div>
      ) : null}
    </div>
  )
}
